"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTeamsRequestState = exports.fetchTeams = void 0;

var fetchTeams = function fetchTeams(state) {
  return state.teams.teamsList;
};

exports.fetchTeams = fetchTeams;

var getTeamsRequestState = function getTeamsRequestState(state) {
  return state.teams.fetchRequestState;
};

exports.getTeamsRequestState = getTeamsRequestState;